import { useEffect } from 'react';
import { setFavicon, FUSION_ICON, OTTO_ICON } from '../../lib/favicon';

// Puts Otto in the tab for staff, and keeps the neutral Fusion mark everywhere
// else — the shared login page included, since it cannot know who is looking at
// it until sign-in completes.
//
// Renders nothing. Takes `isInternal` as a prop rather than reading the session
// itself: App already resolves userType, and a second resolution could disagree
// with the first for a moment, which on this surface means an owl appearing in
// a supplier's tab. One source of truth.
//
// Mounted unconditionally, unlike its Otto siblings. Those are gated on
// `userType === 'internal'` at the call site, but this one has to run for
// suppliers too — reverting the icon is the whole job.
export default function OttoFavicon({ isInternal }) {
  useEffect(() => {
    setFavicon(isInternal ? OTTO_ICON : FUSION_ICON);
  }, [isInternal]);

  return null;
}
